import { includes, map, merge, placeholder, toArray, toString } from 'lodash/fp';

import decodeFormField from './decodeFormField';

const mapCountries = map(ctry => ({
  code: ctry.iso_alpha_2_code ? ctry.iso_alpha_2_code.toLowerCase() : '',
  label: ctry.name,
  value: toString(ctry.id),
  states: ctry.states
}));

const mapStates = (countries, selectedCountryId) => {
  if (!selectedCountryId) {
    return [];
  }
  const { states } = countries.find(cty => cty.id === selectedCountryId);

  if (!states) {
    return [];
  }

  return states.map(opt => ({
    code: opt.code ? opt.code.toLowerCase() : '',
    label: opt.name,
    value: toString(opt.id),
    disabled: opt.active === 0
  }));
};

const showValidation = includes(placeholder, ['first_name', 'last_name', 'email', 'phone']);

function decodeFormFields(data = [], initialValues = {}) {
  return data.reduce((memo, item) => {
    const field = decodeFormField(item);

    if (item.key === 'address') {
      const subfields = toArray(merge(item.settings, item.ui_settings));
      return subfields.reduce((innerMemo, subfield) => {
        const { key } = subfield;

        if (key === 'address') {
          return {
            ...innerMemo,
            streetAddress: {
              ...decodeFormField(subfield),
              key: 'streetAddress',
              name: 'streetAddress',
              size: 'half',
              value: toString(initialValues.address) || ''
            }
          };
        }
        if (key === 'country_id') {
          return {
            ...innerMemo,
            country_id: {
              ...decodeFormField(subfield),
              type: 'autocomplete',
              options: mapCountries(item.countries),
              value: toString(initialValues.country_id) || ''
            }
          };
        }
        if (key === 'state_id') {
          return {
            ...innerMemo,
            state_id: {
              ...decodeFormField(subfield),
              type: 'autocomplete',
              options: mapStates(item.countries, initialValues.country_id) || [],
              value: initialValues.state_id ? toString(initialValues.state_id) : ''
            }
          };
        }
        return {
          ...innerMemo,
          [key]: {
            ...decodeFormField(subfield),
            size: 'half',
            value: toString(initialValues[key]) || ''
          }
        };
      }, memo);
    }

    return {
      ...memo,
      [item.key]: {
        ...field,
        valid: showValidation(item.key) && !!initialValues[item.key],
        value: initialValues[item.key] || ''
      }
    };
  }, {});
}

export default decodeFormFields;
